import React from 'react';

const Header = ()=>{
    return (
        <>
            <header>
                <h1>Note Keeper ++</h1>
            </header>
        </>
    )
}

export default Header;